/** Keep a metadata preview inside the viewport, below its anchor when space allows. */
export function metadataPreviewPosition(anchor: { left: number; top: number; bottom: number } | undefined, viewport: { width: number; height: number }, size: { width: number; height: number }): { left: number; top: number } {
  const margin = 12;
  const maxLeft = Math.max(margin, viewport.width - size.width - margin);
  const maxTop = Math.max(margin, viewport.height - size.height - margin);
  const below = (anchor?.bottom || 0) + 8;
  const preferredTop = below <= maxTop ? below : (anchor?.top || 0) - size.height - 8;

  return {
    left: Math.max(margin, Math.min(anchor?.left || margin, maxLeft)),
    top:  Math.max(margin, Math.min(preferredTop, maxTop)),
  };
}
